<template>
	<div ref="treeView" class="component-groups-tree-container">
		<el-popover :width="400" trigger="click">
			<template #reference>
				<div class="tree-popover-wrapper" @click="stopEventPropagation">
					<div style="width: 100%; padding-left: .388rem;">
						<el-tag v-if="selectedComponents.length" closable @click="onComponentTagClick"
							@close="(e) => onComponentTagCloseClick(selectedComponents[0].value, e)">
							{{ selectedComponents[0].label }}
						</el-tag>

						<el-tag style="margin: 0 .3rem;" v-if="selectedComponents.length > 1" @click="stopEventPropagation">
							+ {{ selectedComponents.length }}
						</el-tag>

						<el-text v-if="!selectedComponents.length" style="padding-left: .388rem; color: var(--el-text-color-placeholder)">
							Фильтр по группам компонентов
						</el-text>
					</div>

					<div>						
						<el-icon v-if="!componentGroupsTree?.length" @click="stopEventPropagation" class="show-tree-icon disabled" size="large"><Memo /></el-icon>
						<el-icon v-else class="show-tree-icon" size="large"><Memo /></el-icon>
					</div>					
				</div>

			</template>
			<el-scrollbar class="component-groups-scrollbar">
				<el-tree :loading="isAsyncOperationPending" ref="elTree" class="component-groups-tree" show-checkbox
					check-strictly node-key="value" :data="componentGroupsTree"
					:props="{ children: 'children', label: 'label' }" :filter-node-method="filterGrpupsTree"
					@check-change="onTreeChange">
					<template #empty>
						&nbsp;
					</template>
				</el-tree>
			</el-scrollbar>
		</el-popover>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Memo } from '@element-plus/icons-vue';
import { ElInput, ElNotification, ElTree } from 'element-plus';
import LinkedLabelValuePair from '@/models/LinkedLabelValuePair';
import store from '@/store';
import LabelValuePair from '@/models/LabelValuePair';
import JobComponentGroupsApiHelper from '@/helpers/api/JobComponentGroupsApiHelper';
import { watch, WatchStopHandle } from 'vue';

@Options({
	components: {
		ElInput, ElTree, Memo
	},
	props: {
		modelValue: Array
	},
	emits: ['update:modelValue']
})
export default class ComponentGroupsTreeFilterComponent extends Vue {
	/** props */
	modelValue!: Array<LinkedLabelValuePair<string, number>>;

	/** constants */
	treeElement!: any;

	/** view-models */
	isAsyncOperationPending = true;
	selectedComponents: Array<LabelValuePair<string, number>> = [];
	componentGroupsTree: Array<LinkedLabelValuePair<string, number>> | null = null;

	stopEmittingModelUpdate = false;

	modelValueWatchHandle: WatchStopHandle | null = null;

	mounted(): void {
		this.treeElement = this.$refs.elTree;
		this.fetchGroupsTreeAsync();

		this.modelValueWatchHandle = watch(
			() => this.modelValue,
			(groups) => {
				if (groups.length) {
					groups.map(_ => this.treeElement.setChecked(_.value, true));
				} else {			
					this.stopEmittingModelUpdate = true;
					this.selectedComponents.map(_ => this.treeElement.setChecked(_.value, false));
					this
						.$nextTick()
						.then(() => {
							this.selectedComponents = [];
							this.stopEmittingModelUpdate = false;
						});
				}
			});
	}

	unmounted(): void {
		if (this.modelValueWatchHandle) {
			this.modelValueWatchHandle();
		}
	}

	onTreeChange(node: LinkedLabelValuePair<string, number>) {
		if (this.stopEmittingModelUpdate) {
			return;
		}

		const addedItemIndex = this.selectedComponents.findIndex(_ => _.value == node.value);
		const isAlreadyAdded = addedItemIndex >= 0;
		if (isAlreadyAdded) {
			this.selectedComponents.splice(addedItemIndex, 1);
		} else {
			const lvp = new LabelValuePair<string, number>(node);
			this.selectedComponents.push(lvp);
		}

		this.emitUpdate();
	}

	onComponentTagClick(e: Event) {
		e.stopPropagation();
	}

	stopEventPropagation(e: Event) {
		e.stopPropagation();
	}

	onComponentTagCloseClick(componentId: number, e: Event) {
		e.stopPropagation();
		this.treeElement.setChecked(componentId);
		this.emitUpdate();
	}

	filterGrpupsTree(value: string, data: LinkedLabelValuePair<string, number>) {
		if (!value) {
			return true;
		}

		return data.label.toLowerCase().includes(value.toLowerCase());
	}

	emitUpdate() {
		this.$emit('update:modelValue', this.selectedComponents);
	}

	async fetchGroupsTreeAsync() {
		try {
			this.isAsyncOperationPending = true;

			const apiHelper = new JobComponentGroupsApiHelper();
			const groupsTree = await apiHelper.getComponentGroupsTreeAsync(store.getters.jwt);

			if (groupsTree == null) {
				this.componentGroupsTree = [];
				ElNotification({
					message: 'Ошибка загрузки дерева компонентов',
					type: 'error',
				});
			}
			this.componentGroupsTree = groupsTree;
		}
		finally {
			this.isAsyncOperationPending = false;
		}
	}
}
</script>

<style scoped>
.component-groups-tree-container {
	width: 100%;
}

	.component-groups-tree-container .tree-popover-wrapper {
		width: 100%;
		align-items: center;
		background-color: var(--el-fill-color-blank);
		border-radius: var(--el-border-radius-base);
		box-shadow: 0 0 0 1px var(--el-border-color) inset;
		box-sizing: border-box;
		cursor: pointer;
		display: flex;
		font-size: 14px;
		gap: 6px;
		min-height: 32px;
		position: relative;
		text-align: left;
		transition: var(--el-transition-duration);
	}

	.component-groups-tree-container .tree-popover-wrapper .show-tree-icon {
		cursor: pointer;
		transition: ease-in-out color .1s;
		color: var(--el-text-color-placeholder);
		margin: 6px 8px 0 8px;
	}

		.component-groups-tree-container .tree-popover-wrapper .show-tree-icon:active {
			color: var(--el-color-primary);
		}

		.component-groups-tree-container .tree-popover-wrapper .show-tree-icon .disabled {
			cursor: default;
			color: var(--el-text-color-disabled);
		}
</style>